// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3HFKy","footer":"ModalError_footer__2JYxP"};